import { collection, doc, query, where } from "firebase/firestore";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import { Client } from "../models/client";
import { Case } from "../models/case";

export const useMyCases = (userEmail: string): Case[] => {
  const firestore = useFirestore();
  const coll = collection(firestore, "cases");
  const qref = query(coll, where("allEmails", "array-contains", userEmail));

  const { data: posts } = useFirestoreCollectionData(qref, {
    idField: "id",
  });

  return (posts as any) || [];
};
